module.exports = __webpack_public_path__ + "static/media/main-character-row.8f599e35.png";